/* global  Vimeo MktoForms2 */

(function () {
	"use strict";

	function scrollHashAnchorIntoView () {

		if (location.hash) {

			const hash = location.hash.substring(1);

			const element = document.querySelector(`#${hash}`);

			if (element) {

				element.scrollIntoView({ 
					behavior: "smooth",
					block: "start"
				});

			}

		}

	}

	// call function every time the hash changes
	//document.addEventListener("hashchange", scrollHashAnchorIntoView);

	// if you really want to wait until two seconds after the page loads, then use this code instead of the line above
	window.addEventListener("load", function () {

		setTimeout(scrollHashAnchorIntoView, 2000);

	});

}());

/*
 * Play video when user clicks poster image
 */
(function() {
	"use strict";

	var poster = document.querySelector(".poster");
	var playIcon = document.querySelector(".play-icon");
	poster.addEventListener("click", playVideo);
	playIcon.addEventListener("click", playVideo);

	function playVideo() {
		var iframe = document.querySelector("iframe");
		var player = new Vimeo.Player(iframe);
		poster.classList.add("hidden");
		playIcon.classList.add("hidden");
		player.play();
	}
} ());


/* Set focused input element */

MktoForms2.whenRendered(function (form) {

	form.getFormElem().find("input[name=FirstName]").focus();

	var svg = '<svg viewBox="0 0 130.2 130.2" version="1.1" xmlns="http://www.w3.org/2000/svg" class="blue-checkmark"> \
					<rect class="rectangle" fill="#F0F5FA" width="130.2" height="130.2" rx="14" /> \
					<polyline class="path check" fill="none" stroke="#2E8BE0" stroke-width="16" stroke-linecap="round" \
						stroke-miterlimit="10" points="100.2,40.2 51.5,88.8 29.8,67.5 " /> \
				</svg>';

	form.getFormElem().find("input[name=Email], \
							input[name=FirstName], \
							input[name=LastName], \
							input[name=Company], \
							input[name=Title], \
							input[name=Phone] \
							").after(svg);

});